export const LANGS = [
  { code: 'fr', flag: '🇫🇷', label: 'Français' },
  { code: 'en', flag: '🇬🇧', label: 'English' },
  { code: 'es', flag: '🇪🇸', label: 'Español' },
  { code: 'gcf', flag: '🇬🇵', label: 'Kréyòl' },
  { code: 'ar', flag: '🇸🇦', label: 'العربية' },
];

// Liste mondiale complète (drapeaux via composant Flag)
export { COUNTRIES as PHONE_COUNTRIES } from './onboarding/countries';

export const LEGAL_STATUSES = ['SARL', 'SAS', 'SASU', 'EURL', 'SA', 'SCOP', 'SCIC', 'EI / Micro-entreprise', 'Association', 'GIE', 'Coopérative', 'Autre'];

export const LEGAL_STATUS_LABELS = {
  en: {
    'SARL': 'SARL — limited liability company',
    'SAS': 'SAS — simplified joint-stock company',
    'SASU': 'SASU — single-shareholder SAS',
    'EURL': 'EURL — single-member limited company',
    'SA': 'SA — public limited company',
    'SCOP': 'SCOP — worker cooperative',
    'SCIC': 'SCIC — collective-interest cooperative',
    'EI / Micro-entreprise': 'EI — sole trader / micro-business',
    'Association': 'Association — non-profit',
    'GIE': 'GIE — economic interest grouping',
    'Coopérative': 'Cooperative',
    'Autre': 'Other',
  },
  es: {
    'SARL': 'SARL — sociedad de responsabilidad limitada',
    'SAS': 'SAS — sociedad por acciones simplificada',
    'SASU': 'SASU — SAS unipersonal',
    'EURL': 'EURL — SRL unipersonal',
    'SA': 'SA — sociedad anónima',
    'SCOP': 'SCOP — cooperativa de trabajo asociado',
    'SCIC': 'SCIC — cooperativa de interés colectivo',
    'EI / Micro-entreprise': 'EI — empresario individual / microempresa',
    'Association': 'Association — asociación sin ánimo de lucro',
    'GIE': 'GIE — agrupación de interés económico',
    'Coopérative': 'Cooperativa',
    'Autre': 'Otro',
  },
  gcf: {
    'EI / Micro-entreprise': 'EI / Mikwo-antrépriz',
    'Association': 'Asosyasyon',
    'Coopérative': 'Koopérativ',
    'Autre': 'Dòt',
  },
  ar: {
    'SARL': 'SARL — شركة ذات مسؤولية محدودة',
    'SAS': 'SAS — شركة مساهمة مبسطة',
    'SASU': 'SASU — شركة مساهمة مبسطة بشريك واحد',
    'EURL': 'EURL — شركة فردية ذات مسؤولية محدودة',
    'SA': 'SA — شركة مساهمة',
    'SCOP': 'SCOP — تعاونية إنتاج عمالية',
    'SCIC': 'SCIC — تعاونية ذات مصلحة جماعية',
    'EI / Micro-entreprise': 'EI — مؤسسة فردية / مشروع صغير',
    'Association': 'Association — جمعية',
    'GIE': 'GIE — تجمع مصلحة اقتصادية',
    'Coopérative': 'تعاونية',
    'Autre': 'أخرى',
  },
};

export const legalStatusLabel = (status, lang) => {
  const key = (lang || 'fr').startsWith('gcf') ? 'gcf' : (lang || 'fr').slice(0, 2);
  return LEGAL_STATUS_LABELS[key]?.[status] || status;
};

export const FORM_T = {
  fr: {
    company_label: 'Raison sociale *',
    company_placeholder: 'Nom légal de votre entreprise',
    legal_label: 'Statut juridique *',
    legal_placeholder: 'Sélectionnez un statut',
    firstname_label: 'Prénom du contact *',
    firstname_placeholder: 'Prénom',
    lastname_label: 'Nom du contact *',
    lastname_placeholder: 'Nom',
    email_label: 'Email professionnel *',
    phone_label: 'Téléphone *',
    phone_placeholder: '690 00 00 00',
    message_label: 'Message / Besoins spécifiques',
    message_placeholder: 'Décrivez votre activité, vos besoins, vos questions…',
    send: 'Envoyer ma demande de contact',
    sending: 'Envoi en cours…',
    disclaimer: "En soumettant ce formulaire, vous acceptez d'être contacté par notre équipe commerciale.",
    sent_title: 'Demande envoyée !',
    sent_desc: 'Notre équipe commerciale vous recontacte sous 48h ouvrées.',
    toast_success: 'Votre demande de contact a bien été envoyée',
    toast_error: "Une erreur est survenue, veuillez réessayer",
  },
  en: {
    company_label: 'Company name *',
    company_placeholder: 'Legal name of your company',
    legal_label: 'Legal status *',
    legal_placeholder: 'Select a status',
    firstname_label: 'Contact first name *',
    firstname_placeholder: 'First name',
    lastname_label: 'Contact last name *',
    lastname_placeholder: 'Last name',
    email_label: 'Business email *',
    phone_label: 'Phone *',
    phone_placeholder: '690 00 00 00',
    message_label: 'Message / Specific needs',
    message_placeholder: 'Describe your business, your needs, your questions…',
    send: 'Send my contact request',
    sending: 'Sending…',
    disclaimer: 'By submitting this form, you agree to be contacted by our sales team.',
    sent_title: 'Request sent!',
    sent_desc: 'Our sales team will get back to you within 48 business hours.',
    toast_success: 'Your contact request has been sent',
    toast_error: 'An error occurred, please try again',
  },
  es: {
    company_label: 'Razón social *',
    company_placeholder: 'Nombre legal de su empresa',
    legal_label: 'Forma jurídica *',
    legal_placeholder: 'Seleccione una forma',
    firstname_label: 'Nombre del contacto *',
    firstname_placeholder: 'Nombre',
    lastname_label: 'Apellido del contacto *',
    lastname_placeholder: 'Apellido',
    email_label: 'Correo profesional *',
    phone_label: 'Teléfono *',
    phone_placeholder: '690 00 00 00',
    message_label: 'Mensaje / Necesidades específicas',
    message_placeholder: 'Describa su actividad, sus necesidades, sus preguntas…',
    send: 'Enviar mi solicitud de contacto',
    sending: 'Enviando…',
    disclaimer: 'Al enviar este formulario, acepta ser contactado por nuestro equipo comercial.',
    sent_title: '¡Solicitud enviada!',
    sent_desc: 'Nuestro equipo comercial le responderá en 48 horas laborables.',
    toast_success: 'Su solicitud de contacto ha sido enviada',
    toast_error: 'Se produjo un error, inténtelo de nuevo',
  },
  gcf: {
    company_label: 'Rézon sosyal *',
    company_placeholder: "Non légal a antrépriz a'w",
    legal_label: 'Stati jiridik *',
    legal_placeholder: 'Chwazi on stati',
    firstname_label: 'Ti non kontak-la *',
    firstname_placeholder: 'Ti non',
    lastname_label: 'Non fanmi kontak-la *',
    lastname_placeholder: 'Non',
    email_label: 'Imèl pwofésyonèl *',
    phone_label: 'Téléfòn *',
    phone_placeholder: '690 00 00 00',
    message_label: 'Mesaj / Bzwen spésifik',
    message_placeholder: "Èspliké aktivité a'w, bzwen a'w, késtyon a'w…",
    send: 'Voyé dèmand kontak an mwen',
    sending: 'Voyé ka fèt…',
    disclaimer: "Lè ou voyé fòmilè sa-a, ou asèpté ekip komèsyal an nou kontakté'w.",
    sent_title: 'Dèmand voyé !',
    sent_desc: "Ekip komèsyal an nou ké viré vin' vè'w avan 48 tè ouvrab.",
    toast_success: "Dèmand kontak a'w byen voyé",
    toast_error: 'On pwoblèm ka fèt, éséyé anko',
  },
  ar: {
    company_label: 'الاسم القانوني للشركة *',
    company_placeholder: 'الاسم القانوني لشركتك',
    legal_label: 'الشكل القانوني *',
    legal_placeholder: 'اختر شكلاً قانونياً',
    firstname_label: 'الاسم الأول لجهة الاتصال *',
    firstname_placeholder: 'الاسم الأول',
    lastname_label: 'اسم عائلة جهة الاتصال *',
    lastname_placeholder: 'اسم العائلة',
    email_label: 'البريد الإلكتروني المهني *',
    phone_label: 'الهاتف *',
    phone_placeholder: '690 00 00 00',
    message_label: 'رسالة / احتياجات محددة',
    message_placeholder: 'صف نشاطك واحتياجاتك وأسئلتك…',
    send: 'إرسال طلب التواصل',
    sending: 'جارٍ الإرسال…',
    disclaimer: 'بإرسالك هذا النموذج، فأنت توافق على أن يتواصل معك فريقنا التجاري.',
    sent_title: 'تم إرسال الطلب!',
    sent_desc: 'سيتواصل معك فريقنا التجاري خلال 48 ساعة عمل.',
    toast_success: 'تم إرسال طلب التواصل بنجاح',
    toast_error: 'حدث خطأ، يرجى المحاولة مجدداً',
  },
};
